// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"b96e70f8","787":"e9297ae3"}[chunkId] + ".chunk.js";
};